import React from 'react'
import { BillingAddressList } from '../../../Common'

export const BillingAddress = () => {
  return <BillingAddressList />
}
